export default [
    {
        path: '/(uk/|ru/)?/drivers/default/create',
        name: 'DriverCreate',
        component: () => import('../views/drivers/default/DriverCreate'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Создание нового водителя'
        },
    }, {
        path: '/(uk/|ru/)?/drivers/index',
        name: 'DriversList',
        component: () => import('../views/drivers/default/List'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Водители'
        },
    }, {
        path: '/(uk/|ru/)?/offers/index',
        name: 'offers',
        component: () => import('../views/drivers/oferts/index.vue'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Оферты'
        },
    }, {
        path: '/(uk/|ru/)?/orders/moderation-orders',
        name: 'moderation-offers',
        component: () => import('../views/drivers/orders/moderationOrders'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Заказы на модерации'
        },
    }, {
        path: '/(uk/|ru/)?/work-rule/index',
        name: 'Workrule',
        component: () => import('../views/drivers/workrule/WorkRule'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Условия работы'
        },
    }, {
        path: '/(uk/|ru/)?/orders/list',
        name: 'Orders',
        component: () => import('../views/order/List'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Заказы'
        },
    }, {
        path: '/(uk/|ru/)?/cars/list',
        name: 'CarsList',
        component: () => import('../views/drivers/default/CarsList'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Автомобили'
        },
    }, {
        path: '',
        component: () => import('../views/drivers/Block/Index'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            title: 'Блокировка при смене водителя',
            altNavSubMenuActive: '/block-change-number/index',
        },
        children: [{
            path: '/(uk/|ru/)?/block-change-number/index',
            name: 'BlockedNew',
            component: () => import('../views/drivers/Block/tables/new'),
            query: true,
            props: true,
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-drive',
                title: 'Блокировка при смене водителя'
            },
        }, {
            path: '/(uk/|ru/)?/block-change-number/verify',
            name: 'BlockedVerify',
            component: () => import('../views/drivers/Block/tables/verify'),
            query: true,
            props: true,
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-drive',
                title: 'Блокировка при смене водителя'
            },
        }, {
            path: '/(uk/|ru/)?/block-change-number/blocked',
            name: 'BlockedBlocked',
            component: () => import('../views/drivers/Block/tables/blocked'),
            query: true,
            props: true,
            meta: {
                requiresAuth: true,
                activeSideIcon:'#icon-drive',
                title: 'Блокировка при смене водителя'
            },
        },]
    }, {
        path: '',
        component: () => import('../views/drivers/default/DriverEdit'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-drive',
            altNavSubMenuActive:'/drivers/index',
        },
        children: [
            {
                path: '/(uk/|ru/)?/drivers/default/detail',
                name: 'DriverDetail',
                component: () => import('../views/drivers/default/modules/Detail'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/car',
                name: 'AutoDetail',
                component: () => import('../views/drivers/default/modules/Auto'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/transactions',
                name: 'TransactionsDetails',
                component: () => import('../views/drivers/default/modules/TransactionsDetails'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/changed-details',
                name: 'ParkOrdersChangedDetails',
                component: () => import('../views/drivers/default/modules/ParkOrdersChangedDetails'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/bonus-details',
                name: 'BonusDetails',
                component: () => import('../views/drivers/default/modules/BonusDetails'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/balance-history',
                name: 'BalanceHistory',
                component: () => import('../views/drivers/default/modules/BalanceHistory'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/promo-raffle',
                name: 'PromoRaffle',
                component: () => import('../views/drivers/default/modules/PromoRaffle'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Купоны розыгрыша'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/payments',
                name: 'PaymentsList',
                component: () => import('../views/drivers/default/modules/PaymentsList'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/account',
                name: 'AccountControl',
                component: () => import('../views/drivers/default/modules/AccountControl'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/cards',
                name: 'DriverCardControl',
                component: () => import('../views/drivers/default/modules/DriverCardControl'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/history',
                name: 'History',
                component: () => import('../views/drivers/default/modules/History'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/order',
                name: 'Order',
                component: () => import('../views/drivers/default/modules/Order'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/HoldOrders',
                name: 'HoldOrders',
                component: () => import('../views/drivers/default/modules/HoldOrders'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/statement',
                name: 'Statement',
                component: () => import('../views/drivers/default/modules/Statement'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/AutoPay',
                name: 'AutoPay',
                component: () => import('../views/drivers/default/modules/AutopayTable'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/topup',
                name: 'TopUp',
                component: () => import('../views/drivers/default/modules/TopUp'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '',
                name: 'PromoCodeTabs',
                component: () => import('../views/drivers/default/modules/PromoCodeTabs'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
                children: [
                    {
                        path: '/(uk/|ru/)?/drivers/default/detail/promo/active',
                        name: 'PromoCode',
                        component: () => import('../views/drivers/default/modules/PromoCode'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-drive',
                            title: 'Редактирование водителя'
                        }
                    }, {
                        path: '/(uk/|ru/)?/drivers/default/detail/promo/new',
                        name: 'PromoCodeNew',
                        component: () => import('../views/drivers/default/modules/PromoCodeNew'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-drive',
                            title: 'Редактирование водителя'
                        }
                    }
                ]
            }, {
                path: '',
                name: 'PromoActiveList',
                component: () => import('../views/drivers/default/modules/PromoInfo'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
                children: [
                    {
                        path: '/(uk/|ru/)?/drivers/default/detail/promo',
                        name: 'PromoInfo',
                        component: () => import('../views/drivers/default/modules/PromoActiveList'),
                        query: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-drive',
                            title: 'Редактирование водителя'
                        }
                    }
                ]
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/referral',
                name: 'Referral',
                component: () => import('../views/drivers/default/modules/Referral'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/referral-program',
                name: 'ReferralProgram',
                component: () => import('../views/drivers/default/modules/ReferralProgram'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/log-payment',
                name: 'LogPayment',
                component: () => import('../views/drivers/default/modules/LogPayment'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/drivers-callback',
                name: 'DriversCallback',
                component: () => import('../views/drivers/default/modules/DriversCallback'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/call-history',
                name: 'CallHistory',
                component: () => import('../views/drivers/default/modules/Callhistory'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/payout',
                name: 'PayoutList',
                component: () => import('../views/drivers/default/modules/PayoutList'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Редактирование водителя'
                },
            }, {
                path: '/(uk/|ru/)?/drivers/default/detail/documents',
                name: 'Documents',
                component: () => import('../views/drivers/default/modules/Documents'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-drive',
                    title: 'Документы'
                },
            }
        ]
    },
]
